var p = Object.defineProperty;
var n = (s, t, e) => t in s ? p(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var a = (s, t, e) => (n(s, typeof t != "symbol" ? t + "" : t, e), e);
class o {
  constructor() {
    a(this, "env");
    a(this, "baseUrl");
    this.env = "uat", this.baseUrl = {
      sit: {
        apigateway: "https://apigatewaysit.oppein.com",
        cdnPath: "https://mtdsrestest.oppein.com/",
        ossPath: "https://opyx-mtds-test.oss-cn-shenzhen.aliyuncs.com/"
      },
      uat: {
        apigateway: "https://apigatewayuat.oppein.com",
        cdnPath: "https://mtdsrestest.oppein.com/",
        ossPath: "https://opyx-mtds-test.oss-cn-shenzhen.aliyuncs.com/"
      },
      ver: {
        apigateway: "https://apigatewayver.oppein.com",
        cdnPath: "https://mtdsrestest.oppein.com/",
        ossPath: "https://opyx-mtds-test.oss-cn-shenzhen.aliyuncs.com/"
      },
      pro: {
        apigateway: "https://apigateway.oppein.com",
        cdnPath: "https://mtdsosscdn.oppein.com/",
        ossPath: "https://mtdsosscdn.oppein.com/"
      }
    };
  }
  init(t) {
    return this.env = t, this;
  }
  getBaseUrl() {
    const t = sessionStorage.getItem("oppein-component/env");
    return this.baseUrl[t || this.env];
  }
}
const i = new o();
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/com-components/file-upload/util/baseUrl.js
// module id = 862
// module chunks = 67